module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<section class="apply-quotation wow fadeInUp">\r\n  <div class="container">\r\n    <div class="title">申请报价</div>\r\n    <div class="desc">对我们的产品感兴趣？填写信息立即获取产品报价</div>\r\n    <div class="link"><a href="apply_quotation.html" target="_blank">填写需求信息<i class="iconfont icon-youjiantou"></i></a></div>\r\n  </div>\r\n</section>';

}
return __p
}